import gql from 'graphql-tag';
import { apollo } from 'src/features';
import { parseActivity } from 'api/getActivity';

const mutation = (isExternalOperator) => {
  const privateCustomerData = isExternalOperator
    ? ''
    : `
      lastName
      middleName
    `; // здесь только эти приватные поля запрашиваются
  return gql`
    mutation TakeActivityInWork($activityId: String!, $state: String!) {
      takeActivityInWork(id: $activityId, state: $state) {
        id
        state
        channelName
        channelType
        insertedAt
        appealId
        channel {
          id
          type
          identifier
        }
        markers {
          id
          name
          directory {
            id
            name
          }
        }
        requestType {
            id
            name
            description
            defaultType
            active
        }
        case {
          id
          name
          description
          insertedAt
          updatedAt
          comment
        }
        customer {
          ${privateCustomerData}
          id
          firstName
          identified
        }
        operator {
          id
          name
          firstName
          lastName
          middleName
          displayName
        }
        messages {
          id
          sender
          insertedAt
          body
          isRead
          customerId
          operatorId
          activityId
          receiver
          to
          from
          copies
          auto
          attachments {
            title
            type
            size
            original
            preview
            ext
          }
        }
        isAuthorized
        noAuthorized
      }
    }`;
};

function takeActivityInWork(activityId, state, isExternalOperator = false) {
  return apollo.client.mutate({
    variables: {
      activityId,
      state: state.toUpperCase(),
    },
    mutation: mutation(isExternalOperator),
  }).then((res) => parseActivity(res.data.takeActivityInWork));
}

export default takeActivityInWork;
